import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { loggedInUser } from '../../../../../../../untidy/redux/selectors';

const Root = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

const Username = styled.div`
  margin-left: 12px;
`;

export function SignedInAs() {
  const user = useSelector(loggedInUser);
  if (!user) {
    return <></>;
  }
  return (
    <Root>
      <FontAwesomeIcon icon={faUserCircle} />
      <Username>{user.email}</Username>
    </Root>
  );
}
